<div mat-dialog-title>
    <div class="d-flex justify-content-between">
        <p>Document Number : {{doc_No}}</p>
        <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
    </div>
</div>
<div mat-dialog-content>
    <div class="row eip-mt-20 eip-ml-xs-10 eip-mr-xs-10">
        <div class="col-xl-12 col-lg-12 col-md-12 p-10">
            <kendo-grid #checkListcGrid [kendoGridBinding]="selectedChecklistCollection" [style.maxHeight]="540" [pageable]="false" [sortable]="false" [resizable]="false" [reorderable]="false" [filterable]="false" [selectable]="false" [scrollable]="false" class="k-resizable-grid">
                <kendo-grid-column field="clId" hidden="true"></kendo-grid-column>
                <kendo-grid-column field="clFullName" title="Checklist Name" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.clFullName}}" eipTooltipPosition="auto">{{dataItem.clFullName}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="uploadedByName" title="Attached By" [width]="90">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.uploadedByName}}" eipTooltipPosition="auto">{{dataItem.uploadedByName}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="uploadedOn" [width]="110" title="Attached On">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.uploadedOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.uploadedOn | date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="approvedByName" [width]="80" title="Approved By">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.approvedByName}}" eipTooltipPosition="auto">{{dataItem.approvedByName}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="approvedOn" [width]="110" title="Approved On">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="no-wrap" eipTooltip="{{dataItem.approvedOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.approvedOn | date:'dd-MMM-yyyy'}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="action" title="Checklist Item" [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                        <div #divIcon class="icon-container d-flex align-items-center">
                            <i class="fa fa-external-link" title="Checklist Items" (click)="openChecklistItems(dataItem,'workFlowStatus')" aria-hidden="true"></i>
                        </div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>